export default __webpack_public_path__ + "static/ruinedKingHeroTablet-9b93a79fda0436d3fe49e2f65534b138.png";